import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import Role from '@/Models/Role.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta;

	const { subscribe, set, update } = writable(collect());

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getRoles(pagination = null) {
			let role = new Role();

			let results = pagination ? role.paginate(pagination.size, pagination.number) : role.get();
			return results.then((result) => {
				meta = result.meta;
				set(collect(result.data));
			});
		},

		getRole(roleId) {
			let role = new Role();

			return role.find(roleId).then((result) => {
				set(collect([result]));
			});
		},

		savePermissions(roleId, permissions) {
			let role = new Role();

			return role.addPermissions(roleId, { permissions });
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
